import PropTypes from "prop-types";

// MUI components
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";

// assets
import filterAcrossProducts from "../../assets/icons/filterAcross.png";

// redux
import { useSelector, useDispatch } from "react-redux";
import { updateConsumerFilterValue } from "store/features/matchNetSlice";

function FilterAcrossProductsToggleComponent({ studyTypeMethod = "" }) {
    const dispatch = useDispatch();
    const consumerFilters = useSelector((state) => state.matchNetStore.consumerFilters);
    const filterData = consumerFilters[studyTypeMethod];
    const isFilterAcrossProductsStoreData = filterData.isFilterAcrossProducts;

    const handleFilterAcrossProductsChange = () => {
        dispatch(
            updateConsumerFilterValue({
                studyTypeMethodTitle: studyTypeMethod,
                key: "isFilterAcrossProducts",
                value: !isFilterAcrossProductsStoreData,
            })
        );
    };

    return (
        <Button
            size="small"
            className="custom-btn custom-btn-outlined-2 color-blue me-4 bold-content"
            variant="outlined"
            startIcon={
                <img
                    style={{ height: "16px" }}
                    src={filterAcrossProducts}
                    alt="Filter Across Products"
                />
            }
        >
            Filter across products
            <Switch
                size="small"
                checked={isFilterAcrossProductsStoreData}
                onChange={handleFilterAcrossProductsChange}
            />
        </Button>
    );
}

// Typechecking props for the OverallKpi
FilterAcrossProductsToggleComponent.propTypes = {
    studyTypeMethod: PropTypes.string,
};

export default FilterAcrossProductsToggleComponent;
